/*
 * Aretina · Inyecta el promedio numérico (1 decimal) en el widget Star Rating New de Revie.
 * El widget oficial solo muestra estrellas + count, pero el diseño anterior incluía el avg numérico.
 * Lee `--rating` del <i data-star> y antepone <span class="rvst-avg">X.X</span>.
 */
(function(){
  function injectAverage(){
    var blocks = document.querySelectorAll('#rvst > div, [id^="rvst"] > div');
    blocks.forEach(function(div){
      if (div.querySelector('.rvst-avg')) return; // ya inyectado
      var star = div.querySelector('[data-star]');
      if (!star) return;
      var raw = star.style.getPropertyValue('--rating');
      if (!raw) {
        // fallback: parsear del title del div
        var t = div.getAttribute('title') || '';
        raw = parseFloat(t);
      }
      var n = parseFloat(raw);
      if (isNaN(n)) return;
      var rounded = (Math.round(n * 10) / 10).toFixed(1);
      var span = document.createElement('span');
      span.className = 'rvst-avg';
      span.textContent = rounded;
      div.insertBefore(span, star);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectAverage);
  } else {
    injectAverage();
  }
  // El widget puede inyectarse async — observamos el body para captar inserciones tardías
  var mo = new MutationObserver(function(){ injectAverage(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
